(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozysnozy-horizon-upsell"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.cuReady === 'true') return;
    root.dataset.cuReady = 'true';

    const list = root.querySelector('[data-cu-list]');
    const total = root.querySelector('[data-cu-total]');
    const compare = root.querySelector('[data-cu-compare]');
    const button = root.querySelector('[data-cu-add]');
    const status = root.querySelector('[data-cu-status]');
    const ar = root.dataset.locale === 'ar';
    const rootUrl = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => {
      try {
        return new Intl.NumberFormat(ar ? 'ar-EG' : (root.dataset.locale || 'en'), {
          style: 'currency', currency
        }).format(Number(cents || 0) / 100);
      } catch (_) { return (Number(cents || 0) / 100).toFixed(2) + ' ' + currency; }
    };
    const read = (attribute) => {
      try { return JSON.parse(root.querySelector(attribute)?.textContent || 'null'); }
      catch (err) { console.error('[CozySnozy upsell] Invalid product JSON', err); return null; }
    };
    const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[char]);
    const current = read('[data-cu-current]');
    const manual = read('[data-cu-manual]') || [];
    const collection = read('[data-cu-collection]') || [];
    if (!current?.id || !Array.isArray(current.variants)) return;

    const normalize = (p) => ({
      id: Number(p.id), title: String(p.title || ''), url: String(p.url || '#'),
      image: typeof p.image === 'string' ? p.image
        : (typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image?.src || '')),
      optionNames: (p.option_names || p.options || []).map((o) => typeof o === 'string' ? o : (o?.name || '')),
      selectedId: Number(p.selected_variant_id || 0),
      variants: (p.variants || []).map((v) => ({
        id: Number(v.id), title: String(v.title || ''), options: v.options || [],
        available: v.available === true, price: Number(v.price || 0),
        compare: Number(v.compare_at_price || 0)
      }))
    });
    const base = normalize(current);
    if (!base.variants.some((v) => v.available)) return;
    const hideSoldOut = root.dataset.hideSoldOut === 'true';
    const suggestions = (products) => {
      const seen = new Set([base.id]);
      return (products || []).map(normalize).filter((p) => {
        if (!p.id || seen.has(p.id) || !p.variants.length) return false;
        if (hideSoldOut && !p.variants.some((v) => v.available)) return false;
        seen.add(p.id); return true;
      }).slice(0, 2);
    };
    const variantLabel = (p, v) => {
      if (p.variants.length === 1 && (v.title === 'Default Title' || !v.title)) {
        return ar ? 'الخيار الافتراضي' : 'Default';
      }
      // Show the FULL option combination: different colors must never collapse into one size.
      return v.title && v.title !== 'Default Title'
        ? v.title : (Array.isArray(v.options) ? v.options.join(' / ') : '');
    };
    const card = (p, main) => {
      const variants = p.variants;
      const selected = main && p.selectedId ? variants.find((v) => v.id === p.selectedId && v.available) : null;
      const first = selected || variants.find((v) => v.available) || variants[0];
      if (!first) return '';
      const options = variants.map((v) => `<option value="${v.id}" ${v.id === first.id ? 'selected' : ''} ${!v.available ? 'disabled' : ''}>${escape(variantLabel(p, v))}${!v.available ? (ar ? ' — نفد' : ' — Sold out') : ''}</option>`).join('');
      const image = p.image ? `<img loading="lazy" width="260" height="325" src="${escape(p.image)}" alt="${escape(p.title)}">` : '';
      const oldPrice = first.compare > first.price ? money(first.compare) : '';
      return `<article class="cu-card" data-cu-card data-current="${main}">
        ${main ? '' : `<input type="checkbox" class="cu-checkbox" checked data-cu-check aria-label="${escape((ar ? 'اختيار ' : 'Select ') + p.title)}">`}
        <a class="cu-card__image" href="${escape(p.url)}">${image}</a>
        <div class="cu-card__details">
          ${main ? `<span class="cu-card__tag">${ar ? 'المنتج الحالي' : 'Current product'}</span>` : ''}
          <a class="cu-card__title" href="${escape(p.url)}">${escape(p.title)}</a>
          <div class="cu-prices"><span class="cu-compare" data-cu-old>${escape(oldPrice)}</span><span class="cu-price" data-cu-price>${escape(money(first.price))}</span></div>
          <select class="cu-select" data-cu-variant aria-label="${escape((ar ? 'اختر خيار ' : 'Choose variant for ') + p.title)}">${options}</select>
        </div>
      </article>`;
    };
    let shown = [];
    const selectedVariant = (cardEl, p) => p.variants.find((v) => v.id === Number(cardEl.querySelector('[data-cu-variant]')?.value));
    function update() {
      let amount = 0, original = 0, count = 0;
      list.querySelectorAll('[data-cu-card]').forEach((el, i) => {
        if (el.dataset.current !== 'true' && !el.querySelector('[data-cu-check]')?.checked) return;
        const variant = selectedVariant(el, shown[i]);
        if (!variant?.available) return;
        count++;
        amount += variant.price;
        original += Math.max(variant.price, variant.compare);
        el.querySelector('[data-cu-price]').textContent = money(variant.price);
        el.querySelector('[data-cu-old]').textContent = variant.compare > variant.price ? money(variant.compare) : '';
      });
      // Update prices on unchecked cards too when their variant changes.
      list.querySelectorAll('[data-cu-card]').forEach((el, i) => {
        const v = selectedVariant(el, shown[i]);
        if (!v) return;
        el.querySelector('[data-cu-price]').textContent = money(v.price);
        el.querySelector('[data-cu-old]').textContent = v.compare > v.price ? money(v.compare) : '';
      });
      total.textContent = money(amount);
      compare.textContent = original > amount ? money(original) : '';
      button.disabled = !count;
    }
    function render(raw) {
      const extra = suggestions(raw);
      if (!extra.length) { root.hidden = true; return; }
      shown = [base, ...extra];
      list.innerHTML = shown.map((p, i) => card(p, i === 0) + (i < shown.length - 1 ? '<span class="cu-plus" aria-hidden="true">+</span>' : '')).join('');
      root.hidden = false;
      list.addEventListener('change', update);
      update();
    }
    button.addEventListener('click', async () => {
      const items = [];
      list.querySelectorAll('[data-cu-card]').forEach((el, i) => {
        if (el.dataset.current !== 'true' && !el.querySelector('[data-cu-check]')?.checked) return;
        const variant = selectedVariant(el, shown[i]);
        if (variant?.available) items.push({ id: variant.id, quantity: 1 });
      });
      if (!items.length || button.disabled) return;
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = ar ? 'جاري الإضافة...' : 'Adding...';
      status.textContent = '';
      status.removeAttribute('data-error');
      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Cart error');
        // Horizon's cart UI uses events/components, not Dawn's <cart-drawer>.
        // Navigating to the native cart avoids a stale cart icon/drawer and guarantees
        // Shopify's automatic discounts are calculated against the actual cart.
        window.location.assign(root.dataset.cartUrl || rootUrl + 'cart');
      } catch (err) {
        console.error('[CozySnozy upsell]', err);
        status.setAttribute('data-error', '');
        status.textContent = ar ? 'تعذرت الإضافة. تأكد من الكمية والمخزون ثم حاول مجددًا.'
          : 'Could not add these products. Check availability and try again.';
        button.textContent = originalText;
        update();
      }
    });
    if (root.dataset.manual === 'true') { render(manual); return; }
    if (root.dataset.mode === 'collection') { render(collection); return; }
    fetch(rootUrl + 'recommendations/products.json?product_id=' + encodeURIComponent(base.id) + '&limit=10&intent=related', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then((r) => { if (!r.ok) throw new Error('Recommendations error'); return r.json(); })
      .then((data) => {
        const related = suggestions(data.products || []);
        render(related.length ? related : collection);
      })
      .catch(() => render(collection));
  }
  function initAll(scope) {
    if (scope?.matches?.('[data-cu-root]')) init(scope);
    scope?.querySelectorAll?.('[data-cu-root]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-hero-slider]';

    class HeroBannerSlider {
      constructor(root) {
        this.root = root;
        this.viewport = root.querySelector('[data-slider-viewport]');
        this.track = root.querySelector('[data-slider-track]');

        /* Remove clones left by Theme Editor re-initialisation. */
        this.track?.querySelectorAll('[data-slider-clone]').forEach((clone) => clone.remove());

        this.slides = [...root.querySelectorAll('[data-slider-slide]:not([data-slider-clone])')];
        this.dots = [...root.querySelectorAll('[data-slider-dot]')];
        this.prevBtn = root.querySelector('[data-slider-prev]');
        this.nextBtn = root.querySelector('[data-slider-next]');

        this.transition = root.dataset.transition || 'fade';
        this.autoplay = root.dataset.autoplay === 'true';
        this.speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
        this.count = this.slides.length;
        this.index = 0;
        this.visualIndex = 1;

        this.timer = null;
        this.progressRaf = null;
        this.progressStart = 0;
        this.progressElapsed = 0;
        this.isPaused = false;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.pointerId = null;
        this.pointerStartX = 0;
        this.pointerStartY = 0;
        this.pointerStartTime = 0;
        this.pointerStartIndex = 0;
        this.isPointerTracking = false;
        this.dragDx = 0;
        this.dragAxis = null;
        this.isPointerDown = false;
        this.didDrag = false;
        this.dragLayoutActive = false;
        this.pendingDragFinish = false;
        this.suppressClickUntil = 0;

        this.resizeHandler = () => {
          this.updateViewportHeight();
          if (this.transition === 'slide' && !this.isPointerDown) {
            this.snapTrack(this.visualIndex);
          }
        };
        this.transitionEndHandler = (event) => this.onTrackTransitionEnd(event);
        this.visibilityHandler = () => {
          document.hidden ? this.pause() : this.resume();
        };
        this.clickGuardHandler = (event) => {
          if (performance.now() < this.suppressClickUntil && event.target.closest('a')) {
            event.preventDefault();
            event.stopPropagation();
          }
        };

        this.setupInfiniteTrack();
        this.bindEvents();
        this.updateActiveSlides();
        this.updateViewportHeight();

        if (this.transition === 'slide' && this.count > 1) {
          this.snapTrack(this.visualIndex);
        }

        this.resetProgressCycle();
      }

      setupInfiniteTrack() {
        if (!this.track || this.count <= 1) {
          this.allSlides = this.slides;
          return;
        }

        const firstClone = this.slides[0].cloneNode(true);
        const lastClone = this.slides[this.count - 1].cloneNode(true);

        [firstClone, lastClone].forEach((clone) => {
          clone.dataset.sliderClone = 'true';
          clone.classList.remove('is-active');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        });

        this.track.insertBefore(lastClone, this.slides[0]);
        this.track.appendChild(firstClone);
        this.allSlides = [lastClone, ...this.slides, firstClone];
      }

      bindEvents() {
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index, 10);
            this.goTo(index, true);
          });
        });

        this.prevBtn?.addEventListener('click', () => this.prev(true));
        this.nextBtn?.addEventListener('click', () => this.next(true));

        this.viewport?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.viewport?.addEventListener('pointermove', (event) => this.onPointerMove(event), { passive: false });
        this.viewport?.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.viewport?.addEventListener('pointercancel', (event) => this.onPointerCancel(event));
        this.viewport?.addEventListener('click', this.clickGuardHandler, true);

        this.track?.addEventListener('transitionend', this.transitionEndHandler);
        window.addEventListener('resize', this.resizeHandler, { passive: true });
        document.addEventListener('visibilitychange', this.visibilityHandler);

        /* Autoplay intentionally keeps running while the banner is hovered or touched. */
      }

      getActiveRatio() {
        const slide = this.slides[this.index] || this.slides[0];
        if (!slide) return 2;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const rawRatio = isMobile ? slide.dataset.ratioMobile : slide.dataset.ratioDesktop;
        const ratio = parseFloat(rawRatio);

        return Number.isFinite(ratio) && ratio > 0 ? ratio : 2;
      }

      updateViewportHeight() {
        if (!this.viewport) return;

        const width = this.viewport.clientWidth;
        const ratio = this.getActiveRatio();

        if (width > 0 && ratio > 0) {
          this.viewport.style.height = `${Math.round(width / ratio)}px`;
        }
      }

      onPointerDown(event) {
        if (this.count <= 1 || event.isPrimary === false || event.button > 0) return;
        if (event.target.closest('[data-slider-dot], [data-slider-prev], [data-slider-next], .hero-banner-slider__button')) return;

        /*
         * A simple hover, tap or long press must never stop autoplay.
         * Drag mode starts only after a real horizontal movement is detected.
         */
        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        this.pointerStartTime = performance.now();
        this.pointerStartIndex = this.index;
        this.dragDx = 0;
        this.dragAxis = null;
        this.isPointerTracking = true;
        this.isPointerDown = false;
        this.didDrag = false;
        this.pendingDragFinish = false;
      }

      beginHorizontalDrag(event) {
        if (this.isPointerDown) return;

        this.isPointerDown = true;

        /* Only an actual horizontal swipe temporarily owns the slide movement. */
        this.clearTimer();
        this.prepareDragLayout();
        this.track?.classList.add('is-dragging');
        this.root.classList.add('is-dragging');

        try {
          this.viewport.setPointerCapture(event.pointerId);
        } catch (_) {}
      }

      onPointerMove(event) {
        if (!this.isPointerTracking || event.pointerId !== this.pointerId) return;

        const dx = event.clientX - this.pointerStartX;
        const dy = event.clientY - this.pointerStartY;

        if (!this.dragAxis && Math.max(Math.abs(dx), Math.abs(dy)) > 6) {
          this.dragAxis = Math.abs(dx) > Math.abs(dy) * 1.05 ? 'x' : 'y';

          if (this.dragAxis === 'x') {
            this.beginHorizontalDrag(event);
          }
        }

        if (this.dragAxis === 'y') {
          this.cancelPointerInteraction(false);
          return;
        }

        if (this.dragAxis !== 'x' || !this.isPointerDown) return;

        event.preventDefault();
        this.didDrag = Math.abs(dx) > 8;

        const width = this.viewport.clientWidth || 1;
        this.dragDx = Math.max(Math.min(dx, width * 0.98), -width * 0.98);
        this.setTrackTransform(this.index + 1, this.dragDx, false);
      }

      onPointerUp(event) {
        if (!this.isPointerTracking || event.pointerId !== this.pointerId) return;

        /* A normal tap/press never interrupts the timer or the filling progress bar. */
        if (!this.isPointerDown || this.dragAxis !== 'x' || !this.didDrag) {
          const slideChangedWhilePressed = this.pointerStartIndex !== this.index;
          if (slideChangedWhilePressed) {
            this.suppressClickUntil = performance.now() + 350;
          }
          this.cancelPointerInteraction(false);
          return;
        }

        const width = this.viewport.clientWidth || 1;
        const elapsed = Math.max(performance.now() - this.pointerStartTime, 1);
        const velocity = this.dragDx / elapsed;
        const passedDistance = Math.abs(this.dragDx) >= width * 0.18;
        const passedVelocity = Math.abs(velocity) >= 0.45;
        const shouldChange = passedDistance || passedVelocity;

        this.suppressClickUntil = performance.now() + 450;
        this.finishPointerCapture(event.pointerId);
        this.track?.classList.remove('is-dragging');
        this.root.classList.remove('is-dragging');
        this.isPointerTracking = false;
        this.isPointerDown = false;

        if (!shouldChange) {
          this.pendingDragFinish = true;
          this.visualIndex = this.index + 1;
          this.setTrackTransform(this.visualIndex, 0, true);
          return;
        }

        const direction = this.dragDx < 0 ? 1 : -1;
        const targetVisualIndex = this.index + 1 + direction;
        this.index = (this.index + direction + this.count) % this.count;
        this.visualIndex = targetVisualIndex;
        this.progressElapsed = 0;

        this.updateActiveSlides();
        this.updateViewportHeight();
        this.renderDots();
        this.animateProgress();
        this.startAutoplay();

        this.pendingDragFinish = true;
        this.setTrackTransform(targetVisualIndex, 0, true);
      }

      onPointerCancel(event) {
        if (!this.isPointerTracking || event.pointerId !== this.pointerId) return;
        this.cancelPointerInteraction(this.didDrag);
      }

      cancelPointerInteraction(suppressClick) {
        if (!this.isPointerTracking && !this.isPointerDown) return;

        if (suppressClick) {
          this.suppressClickUntil = performance.now() + 350;
        }

        const wasDragging = this.isPointerDown && this.dragAxis === 'x';

        this.finishPointerCapture(this.pointerId);
        this.track?.classList.remove('is-dragging');
        this.root.classList.remove('is-dragging');
        this.isPointerTracking = false;
        this.isPointerDown = false;

        if (wasDragging && this.didDrag) {
          this.pendingDragFinish = true;
          this.visualIndex = this.index + 1;
          this.setTrackTransform(this.visualIndex, 0, true);
        } else {
          this.finishDragLayout();
          /* No timer restart is required here: normal taps never stopped it. */
          if (this.autoplay && !this.isPaused && !this.timer) this.startAutoplay();
        }
      }

      finishPointerCapture(pointerId) {
        if (pointerId == null || !this.viewport) return;
        try {
          if (this.viewport.hasPointerCapture(pointerId)) {
            this.viewport.releasePointerCapture(pointerId);
          }
        } catch (_) {}
        this.pointerId = null;
      }

      prepareDragLayout() {
        this.dragLayoutActive = true;
        this.track?.classList.add('is-drag-layout');
        this.visualIndex = this.index + 1;
        this.setTrackTransform(this.visualIndex, 0, false);
      }

      finishDragLayout() {
        if (!this.dragLayoutActive) return;

        if (this.transition !== 'slide') {
          this.track?.classList.remove('is-drag-layout');
          this.track.style.transition = '';
          this.track.style.transform = '';
        } else {
          this.track?.classList.remove('is-drag-layout');
          this.snapTrack(this.visualIndex);
        }

        this.dragLayoutActive = false;
        this.pendingDragFinish = false;
        this.dragAxis = null;
        this.dragDx = 0;
        this.didDrag = false;
      }

      onTrackTransitionEnd(event) {
        if (event.target !== this.track || event.propertyName !== 'transform') return;

        if (this.visualIndex === 0) {
          this.visualIndex = this.count;
          this.snapTrack(this.visualIndex);
        } else if (this.visualIndex === this.count + 1) {
          this.visualIndex = 1;
          this.snapTrack(this.visualIndex);
        }

        if (this.pendingDragFinish) {
          this.finishDragLayout();
          if (this.autoplay && !this.isPaused && !this.timer) this.startAutoplay();
        }
      }

      setTrackTransform(visualIndex, pixelOffset = 0, animate = true) {
        if (!this.track) return;
        this.track.style.transition = animate && !this.prefersReducedMotion
          ? 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)'
          : 'none';
        this.track.style.transform = `translate3d(calc(-${visualIndex * 100}% + ${pixelOffset}px), 0, 0)`;
      }

      snapTrack(visualIndex) {
        this.setTrackTransform(visualIndex, 0, false);
        /* Force layout so the following animated movement starts from the snapped position. */
        void this.track?.offsetWidth;
      }

      prev(manual = false) {
        this.moveBy(-1, manual);
      }

      next(manual = false) {
        this.moveBy(1, manual);
      }

      moveBy(direction, manual = false) {
        if (this.count <= 1 || this.isPointerDown) return;

        if (this.transition === 'slide') {
          this.index = (this.index + direction + this.count) % this.count;
          this.visualIndex += direction;
          this.updateActiveSlides();
          this.updateViewportHeight();
          this.setTrackTransform(this.visualIndex, 0, true);
          this.restartProgressCycle();
        } else {
          this.goTo((this.index + direction + this.count) % this.count, manual);
        }
      }

      goTo(index, manual = false) {
        if (!Number.isFinite(index) || index < 0 || index >= this.count) return;

        if (index === this.index) {
          if (manual) this.restartProgressCycle();
          return;
        }

        const previousIndex = this.index;
        this.index = index;
        this.updateActiveSlides();
        this.updateViewportHeight();

        if (this.transition === 'slide') {
          if (previousIndex === this.count - 1 && index === 0) {
            this.visualIndex = this.count + 1;
          } else if (previousIndex === 0 && index === this.count - 1) {
            this.visualIndex = 0;
          } else {
            this.visualIndex = index + 1;
          }
          this.setTrackTransform(this.visualIndex, 0, true);
        }

        this.restartProgressCycle();
      }

      updateActiveSlides() {
        this.slides.forEach((slide, index) => {
          const isActive = index === this.index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }

      renderDots() {
        this.dots.forEach((dot, index) => {
          const fill = dot.querySelector('[data-progress-fill]');
          const isActive = index === this.index;
          const isCompleted = index < this.index;

          dot.classList.toggle('is-active', isActive);
          dot.classList.toggle('is-completed', isCompleted);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');

          if (fill) {
            fill.style.transition = 'none';
            fill.style.width = isCompleted ? '100%' : '0%';
          }
        });
      }

      resetProgressCycle() {
        this.progressElapsed = 0;
        this.clearTimer();
        this.cancelProgress();
        this.renderDots();
        this.animateProgress();
        if (this.autoplay && !this.isPaused) this.startAutoplay();
      }

      restartProgressCycle() {
        this.resetProgressCycle();
      }

      animateProgress() {
        this.cancelProgress();

        const fill = this.dots[this.index]?.querySelector('[data-progress-fill]');
        if (!fill) return;

        if (this.prefersReducedMotion) {
          fill.style.width = '100%';
          return;
        }

        this.progressStart = performance.now() - this.progressElapsed;

        const step = (now) => {
          if (this.isPaused) {
            this.progressRaf = requestAnimationFrame(step);
            return;
          }

          const elapsed = now - this.progressStart;
          this.progressElapsed = Math.min(elapsed, this.speed);
          const progress = Math.min(this.progressElapsed / this.speed, 1);
          fill.style.width = `${progress * 100}%`;

          if (progress < 1) {
            this.progressRaf = requestAnimationFrame(step);
          }
        };

        this.progressRaf = requestAnimationFrame(step);
      }

      cancelProgress() {
        if (this.progressRaf) {
          cancelAnimationFrame(this.progressRaf);
          this.progressRaf = null;
        }
      }

      startAutoplay() {
        if (!this.autoplay || this.prefersReducedMotion || this.isPaused || this.isPointerDown) return;
        this.clearTimer();
        const remaining = Math.max(this.speed - this.progressElapsed, 0);
        this.timer = setTimeout(() => this.next(false), remaining);
      }

      clearTimer() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }

      pause() {
        if (this.isPaused) return;
        this.isPaused = true;
        this.clearTimer();
      }

      resume() {
        if (!this.isPaused || document.hidden) return;
        this.isPaused = false;
        this.animateProgress();
        this.startAutoplay();
      }

      destroy() {
        this.clearTimer();
        this.cancelProgress();
        this.track?.removeEventListener('transitionend', this.transitionEndHandler);
        this.viewport?.removeEventListener('click', this.clickGuardHandler, true);
        window.removeEventListener('resize', this.resizeHandler);
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.track?.querySelectorAll('[data-slider-clone]').forEach((clone) => clone.remove());
      }
    }

    const instances = new WeakMap();

    const init = (root) => {
      if (instances.has(root)) {
        instances.get(root).destroy();
      }
      instances.set(root, new HeroBannerSlider(root));
    };

    document.querySelectorAll(SECTION_SELECTOR).forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches?.(SECTION_SELECTOR)
        ? event.target
        : event.target.querySelector(SECTION_SELECTOR);
      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.(SECTION_SELECTOR)
        ? event.target
        : event.target.querySelector(SECTION_SELECTOR);
      if (root && instances.has(root)) {
        instances.get(root).destroy();
        instances.delete(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
